import { useTranslation } from 'react-i18next';

import { Button } from '../../components/Button';
import { PageHeader } from '../../components/PageHeader';
import { ErrorNotice } from '../../components/ErrorNotice';
import { Tabs } from '../../components/Tabs';
import { CalendarPanel } from './CalendarPanel';
import { useRunWatchdog } from './queries';
import { SlaPanel } from './SlaPanel';

/**
 * Servicezusagen und Geschaeftszeiten -- F4-01, F4-02.
 *
 * Zwei Reiter auf einer Seite: Eine Zusage ohne Kalender gibt es nicht, und
 * wer die eine einrichtet, braucht den anderen im selben Zug.
 *
 * **Was hier geaendert wird, wirkt nicht rueckwirkend.** Die Frist eines
 * Tickets wird beim Anlegen eingefroren (F4-03); eine neue Zusage gilt fuer
 * die Tickets von morgen. Das steht als Hinweis auf der Seite, weil es die
 * haeufigste Rueckfrage ist.
 */
export function SlaAdminPage() {
  const { t } = useTranslation();
  const watchdog = useRunWatchdog();

  return (
    <>
      <PageHeader
        title={t('sla.title')}
        subtitle={t('sla.subtitle')}
        action={
          /* Derselbe Lauf, den der Hintergrunddienst jede Minute macht -- und
             kein Ersatz dafuer. Er ist fuer den Augenblick nach dem
             Einrichten: Man will wissen, ob die Uhr laeuft, und nicht bis zur
             naechsten Minute raten (F4-06, F4-07). */
          <div className="row">
            <Button
              variant="secondary"
              busy={watchdog.isPending}
              onClick={() => {
                watchdog.mutate();
              }}
            >
              {t('sla.runWatchdog')}
            </Button>
            {watchdog.data ? (
              <span className="field__hint" role="status">
                {t('sla.watchdogResult', {
                  checked: watchdog.data.checked,
                  warnings: watchdog.data.warnings,
                  breaches: watchdog.data.breaches,
                })}
              </span>
            ) : null}
          </div>
        }
      />

      {watchdog.isError ? <ErrorNotice error={watchdog.error} /> : null}

      <Tabs
        ariaLabel={t('sla.title')}
        tabs={[
          { value: 'slas', label: t('sla.slas'), content: <SlaPanel /> },
          { value: 'calendars', label: t('sla.calendars'), content: <CalendarPanel /> },
        ]}
      />
    </>
  );
}
